import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/trash-red.svg'
import _imports_1 from '@/app/ui/assets/svg/lion-parcel-red.svg'
import _imports_2 from '@/app/ui/assets/svg/user-avatar.svg'
import _imports_3 from '@/app/ui/assets/svg/x.svg'
import _imports_4 from '@/app/ui/assets/svg/emoji-chat.svg'
import _imports_5 from '@/app/ui/assets/svg/attachment-chat.svg'
import _imports_6 from '@/app/ui/assets/svg/send-chat.svg'
import _imports_7 from '@/app/ui/assets/svg/send-chat-active.svg'
import _imports_8 from '@/app/ui/assets/svg/warning-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-c74a8e98")

_pushScopeId("data-v-c74a8e98")
const _hoisted_1 = { class: "w-full mx-auto rounded-xl bg-white" }
const _hoisted_2 = {
  key: 0,
  class: "p-4 bg-white border border-gray-300 rounded-t-lg"
}
const _hoisted_3 = { class: "flex flex-row gap-2 p-2 bg-gray-lp-1000 rounded-lg" }
const _hoisted_4 = {
  key: 0,
  class: "bg-white rounded-lg w-16 h-16 shadow p-2 relative"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "trash",
  class: "w-5 h-5"
}, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "bg-white rounded-lg w-16 h-16 shadow p-2 relative"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "trash",
  class: "w-5 h-5"
}, null, -1)
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = {
  key: 0,
  class: "absolute bottom-16 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-50 overflow-y-auto"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "p-3" }, "Daftar mitra", -1)
const _hoisted_11 = {
  key: 0,
  class: "p-3"
}
const _hoisted_12 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_13 = {
  key: 0,
  class: "w-6 h-6"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-full h-full object-contain",
  alt: "Lion Parcel"
}, null, -1)
const _hoisted_15 = {
  key: 1,
  class: "w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center overflow-hidden"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5 h-5 object-cover",
  alt: "User"
}, null, -1)
const _hoisted_17 = { class: "font-medium" }
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "w-5 h-5",
  alt: "emoji"
}, null, -1)
const _hoisted_19 = {
  ref: "editorRef",
  class: "ql-editor flex-1 overflow-y-auto outline-none",
  style: {"max-height":"12.5em"}
}
const _hoisted_20 = { class: "cursor-pointer ml-2 text-xl hover:text-red-lp-100 transition items-center mr-2 my-3" }
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  class: "w-5 h-5",
  alt: "attachment"
}, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "cursor-pointer ml-2 text-xl hover:text-red-lp-100 transition items-center mr-4 my-3"
}
const _hoisted_23 = {
  key: 0,
  src: _imports_6,
  class: "w-5 h-5",
  alt: "send"
}
const _hoisted_24 = {
  key: 1,
  class: "flex text-red-lp-100 text-sm pl-6 gap-2 border border-t-0 border-gray-300 p-2"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("img", {
  src: _imports_8,
  alt: "trash",
  class: "w-5 h-5"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("p", null, "Maksimum 1.000 karakter.", -1)
const _hoisted_27 = {
  ref: "toolbarRef",
  class: "flex flex-wrap items-center rounded-b-lg gap-2 pt-3"
}
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<select class=\"ql-color\" data-v-c74a8e98></select><button class=\"ql-bold\" data-v-c74a8e98></button><button class=\"ql-italic\" data-v-c74a8e98></button><button class=\"ql-underline\" data-v-c74a8e98></button><button class=\"ql-strike\" data-v-c74a8e98></button><button class=\"ql-list\" value=\"bullet\" data-v-c74a8e98></button><button class=\"ql-list\" value=\"ordered\" data-v-c74a8e98></button><button class=\"ql-emoji\" style=\"display:none;\" data-v-c74a8e98></button>", 8)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.uploadedFiles.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.previewFile, (file, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                (file.data)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _createVNode("img", {
                        src: file.data,
                        class: "object-fill w-12 h-12",
                        alt: "uploaded image"
                      }, null, 8, ["src"]),
                      _createVNode("div", {
                        onClick: () => _ctx.removeFile(index),
                        class: "absolute top-0 right-0 bg-white rounded-lg cursor-pointer"
                      }, [
                        _hoisted_5
                      ], 8, ["onClick"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("img", {
                        src: 
                'data:image/svg+xml;utf8,' +
                  encodeURIComponent(
                    `<svg viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M9.69462 0H24L36 12V34.7926C36 37.6711 33.5088 40 30.4403 40H9.57031C6.49114 40 4 37.6711 4 34.7926V5.20733C3.99995 2.32878 6.61539 0 9.69462 0Z' fill='${_ctx.getFileColor(
                      file.name
                    )}'/><path d='M24.0257 8.16V0L36 12H28.0171C24.4248 12 23.8593 9.44 24.0257 8.16Z' fill='white' fill-opacity='0.3'/></svg>`
                  )
              ,
                        class: "object-fill w-12 h-12",
                        alt: "uploaded image"
                      }, null, 8, ["src"]),
                      _createVNode("span", {
                        class: " text-10px font-bold absolute bottom-3 transform left-1/2 -translate-x-1/2",
                        style: {
                color: _ctx.fileExt(file.name) === 'csv' ? '#626262' : '#ffffff'
              }
                      }, _toDisplayString(_ctx.fileExt(file.name).toUpperCase()), 5),
                      _createVNode("div", {
                        onClick: () => _ctx.removeFile(index),
                        class: "absolute top-0 right-0 bg-white rounded-lg cursor-pointer"
                      }, [
                        _hoisted_7
                      ], 8, ["onClick"])
                    ]))
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_8, [
        (_ctx.showMentionList)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _hoisted_10,
              (_ctx.isLoadingMention)
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode(_component_Skeleton, { width: "80%" }),
                      _createVNode(_component_Skeleton, { width: "70%" }),
                      _createVNode(_component_Skeleton, { width: "80%" }),
                      _createVNode(_component_Skeleton, { width: "70%" })
                    ])
                  ]))
                : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.users, (user, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      onClick: ($event: any) => (_ctx.selectMention(user)),
                      class: "cursor-pointer hover:bg-gray-100 px-3 py-2 transition flex flex-row gap-4 mx-2"
                    }, [
                      (user.type === 'agent')
                        ? (_openBlock(), _createBlock("div", _hoisted_13, [
                            _hoisted_14
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_15, [
                            _hoisted_16
                          ])),
                      _createVNode("div", _hoisted_17, _toDisplayString(`${user.type === "agent" ? "Lion parcel" : user.code} - ${
                  user.name
                }`), 1)
                    ], 8, ["onClick"]))
                  }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: 
            `flex flex-row px-2 pt-4 pb-3 border overflow-y-auto border-gray-300 ${
              _ctx.uploadedFiles.length > 0 ? '' : 'rounded-t-lg'
            } flex-wrap gap-2`
          ,
          style: {"max-height":"5rem"}
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mentionSelected, (mention, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "bg-pink-lp-500 flex gap-1 text-red-lp-100 text-14px px-2 rounded whitespace-nowrap h-5"
            }, [
              _createVNode("div", null, " @ " + _toDisplayString(`${mention.type === "agent" ? "Lion parcel" : mention.code} - ${
                  mention.name
                }`), 1),
              _createVNode("img", {
                src: _imports_3,
                class: "w-5 h-5 cursor-pointer opacity-50",
                alt: "x",
                onClick: () => _ctx.removeMention(mention.code)
              }, null, 8, ["onClick"])
            ]))
          }), 128)),
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mentionQuery = $event)),
            placeholder: "Masukkan simbol @ untuk mention seseorang",
            class: "flex-grow outline-none text-12px",
            onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filterUsers && _ctx.filterUsers(...args)))
          }, null, 544), [
            [_vModelText, _ctx.mentionQuery],
            [_directive_click_outside, _ctx.onBlurMention]
          ])
        ], 2)
      ])
    ]),
    _createVNode("div", {
      class: 
        `flex items-center  ${
          _ctx.countChar > 1000
            ? 'border-b-0 border border-gray-300'
            : 'border border-gray-300'
        } min-h-[100px] pt-1`
      
    }, [
      _createVNode("label", {
        class: "cursor-pointer ml-2 text-xl hover:text-red-lp-100 transition items-center my-3",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showEmojiPicker && _ctx.showEmojiPicker(...args)))
      }, [
        _hoisted_18
      ]),
      _createVNode("div", _hoisted_19, null, 512),
      _createVNode("label", _hoisted_20, [
        _hoisted_21,
        _createVNode("input", {
          type: "file",
          class: "hidden",
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
          accept: ".jpeg,.png,.jpg,.pdf,.docx,.csv,.xlsx,.xls,.doc",
          multiple: ""
        }, null, 32)
      ]),
      (_ctx.isSendButton)
        ? (_openBlock(), _createBlock("label", _hoisted_22, [
            (_ctx.isDisableSend)
              ? (_openBlock(), _createBlock("img", _hoisted_23))
              : (_openBlock(), _createBlock("img", {
                  key: 1,
                  src: _imports_7,
                  class: "w-5 h-5",
                  alt: "send",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendChat && _ctx.sendChat(...args)))
                }))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.countChar > 1000)
      ? (_openBlock(), _createBlock("div", _hoisted_24, [
          _hoisted_25,
          _hoisted_26
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_27, [
      _hoisted_28
    ], 512)
  ]))
})